import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { Replay } from '@sentry/replay';

import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";

import { HashRouter } from "react-router-dom";
import { Provider} from 'react-redux';
import {store, persistor} from './redux/store/store';
import {PersistGate} from 'redux-persist/integration/react';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENV,
  debug: true,
  enabled: true,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1.0,
  integrations: [
    new BrowserTracing(),
    new Replay({
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 1.0,
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,
    }),
  ],
});


ReactDOM.render(
<HashRouter>
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
</HashRouter>,
document.getElementById("root")
);

reportWebVitals();
